// extracted by mini-css-extract-plugin
export default {"container":"YgAg0G7gzt"};